import { AUTH_TOKEN } from '@/utils/consts';
import { getAuthCookieOptions } from '@/utils/auth/authCookieOptions';
import { Permissions } from '@/consts/permissions';
import Cookies, { type CookieSetOptions } from 'universal-cookie';
import type { JwtPayloadType } from '@/types/jwtTypes';

type AuthCookiePayload = Readonly<Pick<JwtPayloadType, 'authorities'>>;

export const getAuthTokenCookieOptions = (decoded: AuthCookiePayload): CookieSetOptions =>
    decoded.authorities.includes(Permissions.ROLE_ATG_ADMIN) ? getAuthCookieOptions() : { path: '/' };

export const clearAuthTokenCookies = (cookies: Cookies): void => {
    cookies.remove(AUTH_TOKEN, { path: '/' });
    cookies.remove(AUTH_TOKEN, getAuthCookieOptions());
};
